import React from 'react';
import { Link } from 'react-scroll';
import { NavMenu } from '../styles/navigation.style';

const Navigation = ({ menuOpen, onHideMenu, onSelect, onInputFocus }) => {

    const handleContactFocus = (e) => {
        onSelect(e);
        onInputFocus();
    }

    return (
        menuOpen && (<NavMenu className={ menuOpen ? 'open' : ''}>
            <div className="closeNav outside-shadow hover-in-shadow" onClick={onHideMenu}>
                &times;</div>
            <div className="nav-inner">
                <ul>
                    <li>
                        <Link 
                            name="home"
                            to="/"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                            className="outside-shadow hover-in-shadow"
                            activeClass="active"
                            onClick={(e) => onSelect(e)}
                        >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link 
                            name="about"
                            to="about"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                            className="outside-shadow hover-in-shadow"
                            activeClass="active"
                            onClick={(e) => onSelect(e)}
                        >
                            About
                        </Link>
                    </li>
                    <li>
                        <Link 
                            name="projects"
                            to="projects"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                            className="outside-shadow hover-in-shadow"
                            activeClass="active"
                            onClick={(e) => onSelect(e)}
                        >
                            Portfolio
                        </Link>
                    </li>
                    <li>
                        <Link 
                            name="contact"
                            to="contact"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                            className="outside-shadow hover-in-shadow"
                            activeClass="active"
                            onClick={(e) => handleContactFocus(e)}
                        >
                            Contact
                        </Link>
                    </li>
                </ul>
            </div>
            <p className="copywrite">&copy; 2021, Johnpaul Attamah</p>
        </NavMenu>)
    )
}

export default Navigation
